module.exports = __webpack_public_path__ + "static/media/Scarlett.7d63f967.png";